import { useMemo } from "react";
import { useI18n } from "@wato/i18n/react";
import { useOptionalAuth } from "../auth/AuthProvider";
import { seedCollapsedOnce } from "../features/templates/guide/seed-collapsed";
import { FeatureIntro } from "./FeatureIntro";

/** Pages that get the persistent «كيف تعمل؟» chip from `dashboard.pageHelp.<page>.*`. */
export type PageHelpKey = "home" | "sell";

/**
 * UXR-22: the in-page help chip (PageHeader `help` slot) in three short parts: what this page is,
 * what to do now, what happens next. Starts collapsed; the choice is remembered per user.
 */
export function PageHelp({ pageKey }: { readonly pageKey: PageHelpKey }) {
  const { t } = useI18n();
  const auth = useOptionalAuth();
  const userId = auth?.state.status === "ready" ? auth.state.me.user.id : "anon";
  const featureKey = `page-help-${pageKey}`;
  useMemo(() => seedCollapsedOnce(userId, featureKey), [userId, featureKey]);
  const ns = `dashboard.pageHelp.${pageKey}` as const;
  return (
    <FeatureIntro
      featureKey={featureKey}
      title={t(`${ns}.title` as const)}
      what={t(`${ns}.what` as const)}
      when={t(`${ns}.when` as const)}
      steps={[t(`${ns}.step1` as const), t(`${ns}.step2` as const)]}
    />
  );
}
